import {
  LISTING_PRODUCT_CATEGORIES,
  LISTING_PRODUCT_CATEGORIES_SUCCESS,
  LISTING_PRODUCT_CATEGORIES_FAILED,
  ADDING_PRODUCT_CATEGORIES,
  ADDING_PRODUCT_CATEGORIES_SUCCESS,
  ADDING_PRODUCT_CATEGORIES_FAILED,
  DELETING_PRODUCT_CATEGORIES,
  DELETING_PRODUCT_CATEGORIES_SUCCESS,
  DELETING_PRODUCT_CATEGORIES_FAILED,
  UPDATING_PRODUCT_CATEGORIES,
  UPDATING_PRODUCT_CATEGORIES_SUCCESS,
  UPDATING_PRODUCT_CATEGORIES_FAILED,
  INFO_PRODUCT_CATEGORIES,
  INFO_PRODUCT_CATEGORIES_SUCCESS,
  INFO_PRODUCT_CATEGORIES_FAILED,
  RESET_PRODUCT_CATEGORIES_ADD_STATE,
  RESET_PRODUCT_CATEGORIES_EDIT_STATE,
  RESET_PRODUCT_CATEGORIES_INFO_STATE
} from "./actionTypes"
import { LOGOUT_LOGGEDIN_USER } from "../../auth/login/actionTypes";
import RequestHandler from "../../../helpers/RequestHandler"

// Signout user if token invalid
const signOutUser = () => ({
  type: LOGOUT_LOGGEDIN_USER,
});

const AddProductCategoryInit = () => ({
  type: ADDING_PRODUCT_CATEGORIES
})

const AddProductCategorySuccess = (payload) => ({
  type: ADDING_PRODUCT_CATEGORIES_SUCCESS,
  payload
})

const AddProductCategoryFailed = (payload) => ({
  type: ADDING_PRODUCT_CATEGORIES_FAILED,
  payload
})

export const AddProductCategoryAction = (data) => {
  return (dispatch) => {
    dispatch(AddProductCategoryInit());
    RequestHandler({
      url: "/content-management/product-category",
      data,
      method: 'POST',
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(function (response) {
        const { message } = response.data
        dispatch(AddProductCategorySuccess(message));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(AddProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const ListingProductCategoryInit = () => ({
  type: LISTING_PRODUCT_CATEGORIES
})

const ListingProductCategorySuccess = (payload) => ({
  type: LISTING_PRODUCT_CATEGORIES_SUCCESS,
  payload
})

const ListingProductCategoryFailed = (payload) => ({
  type: LISTING_PRODUCT_CATEGORIES_FAILED,
  payload
})

export const LoadProductCategoryAction = (data) => {
  return (dispatch) => {
    dispatch(ListingProductCategoryInit());
    let base_url = '/content-management/product-categories?';
    const { filter, sort_by, sort_order, per_page_items, current_page, is_active } = data;
    if (filter) {
      base_url += `filter=${filter}&`;
    }
    if (sort_by) {
      base_url += `sort_by=${sort_by}&`;
    }
    if (sort_order) {
      base_url += `sort_order=${sort_order}&`;
    }
    if (per_page_items) {
      base_url += `per_page_items=${per_page_items}&`;
    }
    if (current_page) {
      base_url += `current_page=${current_page}&`;
    }
    if (is_active !== undefined && is_active !== null && is_active !== "") {
      base_url += `is_active=${is_active}&`;
    }
    RequestHandler.get(base_url)
      .then(function (response) {
        const { message, data } = response.data
        const { items, total } = data
        dispatch(ListingProductCategorySuccess({
          items,
          total,
          message
        }));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(ListingProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const InfoProductCategoryInit = () => ({
  type: INFO_PRODUCT_CATEGORIES
})

const InfoProductCategorySuccess = (payload) => ({
  type: INFO_PRODUCT_CATEGORIES_SUCCESS,
  payload
})

const InfoProductCategoryFailed = (payload) => ({
  type: INFO_PRODUCT_CATEGORIES_FAILED,
  payload
})

export const LoadProductCategoryInfoAction = (_id) => {
  return (dispatch) => {
    dispatch(InfoProductCategoryInit());
    let base_url = '/content-management/product-category/'+ _id;
    RequestHandler.get(base_url)
      .then(function (response) {
        const { data } = response.data
        const { item } = data
        dispatch(InfoProductCategorySuccess(item));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(InfoProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

// updating
const UpdateProductCategoryInit = () => ({
  type: UPDATING_PRODUCT_CATEGORIES
})

const UpdateProductCategorySuccess = (payload) => ({
  type: UPDATING_PRODUCT_CATEGORIES_SUCCESS,
  payload
})

const UpdateProductCategoryFailed = (payload) => ({
  type: UPDATING_PRODUCT_CATEGORIES_FAILED,
  payload
})

export const UpdateProductCategoryAction = (id, data) => {
  return (dispatch) => {
    dispatch(UpdateProductCategoryInit());
    RequestHandler({
      url: `/content-management/product-category/${id}`,
      data,
      method: 'PUT',
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(function (response) {
        const { message } = response.data
        dispatch(UpdateProductCategorySuccess(message));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(UpdateProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

// delete

const DeleteProductCategoryInit = () => ({
  type: DELETING_PRODUCT_CATEGORIES
})

const DeleteProductCategorySuccess = (payload) => ({
  type: DELETING_PRODUCT_CATEGORIES_SUCCESS,
  payload
})

const DeleteProductCategoryFailed = (payload) => ({
  type: DELETING_PRODUCT_CATEGORIES_FAILED,
  payload
})

export const DeleteProductCategoryAction = (_id) => {
  return (dispatch) => {
    dispatch(DeleteProductCategoryInit());
    RequestHandler.delete(`/content-management/product-category/${_id}`)
      .then(function (response) {
        const { message } = response.data
        dispatch(DeleteProductCategorySuccess(message));
        dispatch(LoadProductCategoryAction({}));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(DeleteProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const ResetProductCategoryAdd = () => ({
  type: RESET_PRODUCT_CATEGORIES_ADD_STATE
});
const ResetProductCategoryEdit = () => ({
  type: RESET_PRODUCT_CATEGORIES_EDIT_STATE
});
const ResetProductCategoryInfo = () => ({
  type: RESET_PRODUCT_CATEGORIES_INFO_STATE
});

export const ResetProductCategoryAddStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductCategoryAdd());
  }
}

export const ResetProductCategoryEditStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductCategoryEdit());
  }
}

export const ResetProductCategoryInfoStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductCategoryInfo());
  }
}

export const UpdateProductCategoryStatusAction = (id, status, loadData) => {
  return (dispatch) => {
    dispatch(UpdateProductCategoryInit());
    RequestHandler.patch(`/content-management/product-category/${id}`, { is_active: status })
      .then(function (response) {
        const { message } = response.data
        dispatch(UpdateProductCategorySuccess(message));
        dispatch(LoadProductCategoryAction(loadData));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(UpdateProductCategoryFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}